module.exports = __webpack_public_path__ + "static/media/ic_female.6e3a9962.svg";